<body>
    <!-- <div class="site-mobile-menu site-navbar-target style-1 ">
        <div class="site-mobile-menu-header">
            <div class="site-mobile-menu-close mt-3">
                <span class="icon-close2 js-menu-toggle"></span>
            </div>
        </div>
        <div class="site-mobile-menu-body">

        </div>
    </div> -->

    <app-header-new></app-header-new>


    <section>
        <div class="page-header-area sec-overlay sec-overlay-black"
            style="background-image: url('../../../../assets/images/new-images/Inner-Banner.png'); background-repeat: no-repeat;">
            <div class="container pt--0 pb--0">
                <div class="row">
                    <div class="col-12">
                        <div class="page-header-content">
                            <!-- <h2 class="title">Jobs</h2>
                            <nav class="breadcrumb-area">
                                <ul class="breadcrumb justify-content-center">
                                    <li><a href="index.html">Home</a></li>
                                    <li class="breadcrumb-sep"> / </li>
                                    <li>Jobs</li>
                                </ul>
                            </nav>  -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <div>



        <div class="text-center">
            <h4
                style="font-size:18px; top:40%; right:22%;    font-weight: 700;     padding: 10% 0 10% 0; color: #027c92;;">
                Congratulations!<br> Your registration with OUK Internship Portal is successful. <br> Your credentials
                will
                be sent to your registered email after review and approval.
            </h4>

        </div>
        <div>
            <app-footer-new></app-footer-new>
        </div>
    </div>
</body>